import React, { useState, useEffect, useRef } from 'react';
import {
  Snackbar, Alert, Button, Stack, Typography, IconButton,
} from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CloseIcon from '@mui/icons-material/Close';
import { usePushNotifications } from '../hooks/usePushNotifications';

const DISMISS_KEY = 'push_prompt_dismissed_at';
const DISMISS_DAYS = 7;

/**
 * Banner per notifiche push — DISABILITATO.
 * La subscription push avviene automaticamente durante il login via QR code.
 * Il banner non viene più mostrato automaticamente per evitare
 * subscription senza associazione utente-dispositivo.
 */
export default function PushNotificationPrompt() {
  const { isSupported, permission, isSubscribed, loading, subscribe } = usePushNotifications();
  const [open, setOpen] = useState(false);
  const hasActed = useRef(false);

  useEffect(() => {
    // Disabilitato: la subscription push avviene solo tramite QR login.
    // Il banner automatico è stato rimosso per garantire l'associazione
    // utente → dispositivo attraverso il flusso QR code.
    return;
  }, [isSupported, isSubscribed, permission]);

  const handleActivate = async () => {
    hasActed.current = true;
    const ok = await subscribe();
    // Chiudi sempre il banner dopo il tentativo: l'utente ha risposto,
    // non va ripresentato. Se fallisce, il dismiss evita loop.
    localStorage.setItem(DISMISS_KEY, new Date().toISOString());
    setOpen(false);
    if (!ok) {
      console.warn('[Push] Subscription non riuscita, banner non verra\' piu\' mostrato per 7 giorni.');
    }
  };

  const handleDismiss = () => {
    hasActed.current = true;
    localStorage.setItem(DISMISS_KEY, new Date().toISOString());
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ maxWidth: 480 }}
    >
      <Alert
        severity="info"
        icon={<NotificationsActiveIcon />}
        sx={{
          backgroundColor: '#131d2f',
          color: '#e6edf3',
          border: '1px solid rgba(66,165,245,0.3)',
          borderRadius: 2,
          '& .MuiAlert-icon': { color: '#42a5f5' },
        }}
        action={
          <IconButton size="small" color="inherit" onClick={handleDismiss}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
          Attiva le notifiche push per ricevere alert in tempo reale, anche a browser chiuso.
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button
            size="small"
            variant="contained"
            disabled={loading}
            onClick={handleActivate}
            sx={{
              textTransform: 'none',
              backgroundColor: '#42a5f5',
              '&:hover': { backgroundColor: '#1e88e5' },
            }}
          >
            {loading ? 'Attivazione...' : 'Attiva'}
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleDismiss}
            sx={{
              textTransform: 'none',
              backgroundColor: '#546e7a',
              '&:hover': { backgroundColor: '#37474f' },
            }}
          >
            Non ora
          </Button>
        </Stack>
      </Alert>
    </Snackbar>
  );
}
